const Marquee = ({ items }) => (
  <div className="marquee border-y border-white/10 py-6" data-testid="editorial-marquee">
    <div className="marquee-track">
      {[0, 1].map((half) => (
        <div key={half} className="flex items-center shrink-0" aria-hidden={half === 1}>
          {items.map((item, i) => (
            <span key={i} className="flex items-center">
              <span className="font-syne text-xl sm:text-2xl font-bold tracking-tight text-white/25 whitespace-nowrap px-6">
                {item}
              </span>
              <span className="h-1.5 w-1.5 rounded-full bg-flame shrink-0" aria-hidden="true" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default Marquee;
